/**
 * Timezone mode storage.
 */
export type TimezoneMode = 'local' | 'utc';

export const getTimezoneMode = (): TimezoneMode =>
  (localStorage.getItem('timezoneMode') as TimezoneMode) || 'local';

export const saveTimezoneMode = (mode: TimezoneMode): void =>
  localStorage.setItem('timezoneMode', mode);
